<script>
import { mapState } from "vuex";
import { api } from "@/state/services";
import { isMenuItemVisible } from "@/utils/menu-map";
import { isEmbeddedWebView } from "@/utils/webview";

export default {
  data() {
    return {
      slide: 0,
      sliding: null,
      banners: null,
      communityModalVisible: false,
      communityIframeSrc: null,
    }
  },
  methods: {
    onSlideStart() {
      this.sliding = true
    },
    onSlideEnd() {
      this.sliding = false
    },
    getBanners() {
      api
      .get('banners')
      .then((response) => {
        this.banners = response.data.list
      })
    },
    // Mesmo OAuth do item "Comunidade" do side-nav.vue: o link direto da
    // Comunidade dá erro para quem ainda não está logado no Circle.
    getCircleLink() {
      const token = localStorage.getItem('token');

      return `https://api.salesteams.com.br/oauth/authorize` +
            `?client_id=circle` +
            `&redirect_uri=https://comunidade.salesteams.com.br/oauth2/callback` +
            `&response_type=code` +
            `&token=${token}`;
    },
    // Banner da Comunidade só vira link para quem enxerga a Comunidade no menu.
    bannerHref(banner) {
      if (banner.comunidade) {
        return isMenuItemVisible(this.account.user, "comunidade") ? this.getCircleLink() : null;
      }
      return banner.url || null;
    },
    onBannerClick(event, banner) {
      // No app (webview) a nova aba não tem "voltar"; abre a Comunidade num modal, como no menu.
      if (!banner.comunidade || !isEmbeddedWebView()) {
        return;
      }

      event.preventDefault();
      this.communityIframeSrc = this.getCircleLink();
      this.communityModalVisible = true;
    },
    closeCommunityModal() {
      this.communityModalVisible = false;
      this.communityIframeSrc = null;
    }
  },
  mounted() {
    this.getBanners()
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
    monitorWidth: function() {
      var width = screen.width;
      return width;
    }
  }
}
</script>

<template>
  <div id="banners" v-if="banners && banners.length > 0" class="mb-4">
    <b-carousel
      id="carousel"
      class="rounded"
      v-model="slide"
      :interval="4000"
      controls
      indicators
      background="#1c1a22"
      img-height="350"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <b-carousel-slide v-for="banner in banners" :key="banner.index" class="rounded">
        <template v-slot:img>
          <div v-if="monitorWidth < 600">
            <template v-if="bannerHref(banner)">
              <a :href="bannerHref(banner)" :target="banner.comunidade ? '_blank' : null" @click="onBannerClick($event, banner)"><img class="w-100 rounded" :src="banner.image.mobile" :alt="banner.title" /></a>
            </template>
            <template v-else>
              <img class="w-100 rounded" :src="banner.image.mobile" :alt="banner.title" />
            </template>
          </div>
          <div v-else>
            <template v-if="bannerHref(banner)">
              <a :href="bannerHref(banner)" :target="banner.comunidade ? '_blank' : null" @click="onBannerClick($event, banner)"><img class="w-100 rounded" :src="banner.image.desktop" :alt="banner.title" /></a>
            </template>
            <template v-else>
              <img class="w-100 rounded" :src="banner.image.desktop" :alt="banner.title" />
            </template>
          </div>
        </template>
      </b-carousel-slide>
    </b-carousel>

    <b-modal
      v-model="communityModalVisible"
      modal-class="modal-fullscreen-app"
      hide-header
      hide-footer
      no-close-on-backdrop
      @hidden="closeCommunityModal"
    >
      <div class="community-modal-bar d-flex align-items-center justify-content-between">
        <span class="notranslate">Comunidade</span>
        <button type="button" class="btn btn-sm btn-light" @click="closeCommunityModal">
          <i class="mdi mdi-close"></i>
        </button>
      </div>
      <iframe
        v-if="communityIframeSrc"
        :src="communityIframeSrc"
        class="community-modal-iframe"
        frameborder="0"
      ></iframe>
    </b-modal>
  </div>
</template>

<style scoped>
#banners {
  text-align: center;
}
#banners img {
  object-fit: cover;
  aspect-ratio: 16/5;
}
@media (max-width: 600px) {
  #banners img {
    aspect-ratio: auto;
  }
}
.community-modal-bar {
  flex: 0 0 auto;
  padding: 12px 16px;
  border-bottom: 1px solid var(--st-border-soft);
}
.community-modal-iframe {
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
